<ng-template #dayTemplate let-dayValue="dayValue" let-dayString="dayString">
  <div class="calendar-day grow relative">
    <div class="ps-xxsmall-t">{{ dayString }}</div>
    <div class="flight-info" *finLet="(results$ | async) === null || (results$ | async) === undefined as noResults">
      <ng-container
        *finLet="noResults ? 0 : ((results$ | async)[dayValue.date.toString()] || []).length as noOfFlights"
      >
        <ng-container *ngIf="noOfFlights > 0">
          <span class="font-body-1 light-type">{{ noOfFlights }}</span>
          <fcom-icon [name]="SvgLibraryIcon.AIRCRAFT_TILTED" class="icon-small"></fcom-icon>
        </ng-container>
        <div
          class="day-border fill absolute"
          [class.success-500-bg]="noOfFlights > 0"
          [class.grey-200-bg]="noResults || noOfFlights === 0"
        ></div>
      </ng-container>
    </div>
  </div>
</ng-template>

<div
  data-testid="timetable-error"
  class="error-50-bg fill grow absolute z1 flex flex--center flex--column grow"
  *ngIf="(status$ | async) === TimetableStatus.ERROR"
>
  <div class="font-body-1 bold-type ps-xxsmall-t">{{ 'timetable.error.title' | finLocalization }}</div>
  <div class="font-body-2 ps-xxsmall-t">{{ 'timetable.error.notLoading' | finLocalization }}</div>
  <button class="font-body-1 ps-small-t nordic-blue-900-text underline link-hover" (click)="loadTimetables()">
    {{ 'timetable.error.tryAgain' | finLocalization }}
  </button>
</div>
<div
  data-testid="timetable-loading"
  class="grey-25-bg fill grow absolute z1 flex flex--top flex--column grow"
  *ngIf="(status$ | async) === TimetableStatus.LOADING"
>
  <fin-loader [type]="LoaderType.EMBEDDED" [title]="'timetable.loading'"></fin-loader>
</div>

<fcom-calendar
  *ngIf="'datepicker' | finLocalization as uiLabels"
  [dateLabels]="'date' | finLocalization"
  [uiLabels]="uiLabels"
  [isDateRange]="false"
  [minDate]="minDate"
  [maxDate]="maxDate"
  [selectedDates]="selectedDays$ | async"
  [displayMonths]="1"
  [showTags]="true"
  [dayTemplate]="dayTemplate"
  [navigationType]="CalendarNavigation.ARROWS"
  (monthChange)="monthChange($event)"
  (datesSelected)="onDatesSelected($event)"
>
</fcom-calendar>
